var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isShow)?_c('div',{staticClass:"agreement"},[_vm._m(0),_c('div',{staticClass:"al-c"},[_c('a',{staticClass:"btn-100--red",on:{"click":_vm.attentionTermService}},[_vm._v("注意事項を確認する")])])]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"bold mb-30"},[_vm._v(" 必ずお読みいただき確認後、 "),_c('br',{staticClass:"mb-elem"}),_vm._v(" 商品閲覧・購入にお進みください。 "),_c('br'),_vm._v(" （確認後、購入フローへ進むことが可能となります。） ")])
}]

export { render, staticRenderFns }